import React from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

// Cost delta vs previous month: up = more spend (red), down = savings (green).
export function Delta({ now = 0, prev, testid }) {
  if (prev == null) return null;
  const diff = now - prev;
  const same = Math.abs(diff) < 0.00005;
  const pct = prev > 0 ? (diff / prev) * 100 : null;
  const Icon = same ? Minus : diff > 0 ? TrendingUp : TrendingDown;
  const tone = same ? "bg-slate-100 text-slate-500" : diff > 0 ? "bg-rose-50 text-rose-700" : "bg-emerald-50 text-emerald-700";
  const label = same ? "sama" : `${diff > 0 ? "+" : "−"}$${Math.abs(diff).toFixed(4)}${pct != null ? ` (${diff > 0 ? "▲" : "▼"} ${Math.abs(pct).toFixed(1)}%)` : prev === 0 ? " (baru)" : ""}`;
  return <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold ${tone}`} title={`Bulan lalu: $${prev.toFixed(4)}`} data-testid={testid}><Icon size={11} /> {label}</span>;
}
